import React from 'react'
import { useSelector } from 'react-redux'
import { getApiEndpoint } from 'data/config/selectors'
import throttle from 'lodash/throttle'

export default function useDomainAvailability(organizationDomain: string) {
  const [error, setError] = React.useState<string | null>(null)
  const apiEndpoint = useSelector(getApiEndpoint)

  const checkDomainAvailability = React.useCallback(
    throttle((domain: string) => {
      if (!domain || domain.length < 4) {
        return setError('Domain must be at least 4 characters')
      }
      if (domain === organizationDomain) {
        return setError(null)
      }

      fetch(`${apiEndpoint}/organizations/domains/${domain}`)
        .then(async response => {
          if (response.status > 400) {
            setError('Unable to check domain availability')
          }
          return response
        })
        .then(response => response.json())
        .then(({ data }) => {
          if (data.attributes.available) {
            return setError(null)
          }
          return setError('Domain is not available')
        })
    }, 500),
    [apiEndpoint, organizationDomain]
  )

  return {
    checkDomainAvailability,
    error,
  }
}
